import React, { useContext } from 'react'
import SearchContext from '../../context/SearchContext'
import AppContext from '../../context/AppContext'

const Subscription = () => {
    const {params, loading} = useContext(SearchContext)
    const {subscription_url} = useContext(AppContext)

    const urlparams = new URLSearchParams();
    const subscription_tags = ['manufacturer', 'modelSeries', 'fuelType', 'gearboxType'].map((paramName)=>{
        if( params.has(paramName)) {
            urlparams.append(paramName, params.get(paramName))
            return (
                <span key={paramName} className="subscription_tag my-1">{params.get(paramName)}</span>
            )
        }
    }).filter( tag => Boolean(tag))


    if(!loading && subscription_tags.length > 0) {
        return (
            <div className="subscription-box">

                <h2>Inget som riktigt passade?</h2>
                <p>Då är vår kostnadsfria bevakningstjänst perfekt för dig. <br />Starta bevakning och få en personlig fordonsbevakare hos oss som letar bil åt dig!</p>
                <h5>BEVAKNINGEN INNEFATTAR:</h5>
                <div className="tags">
                { subscription_tags.map( tag => tag)}
                </div>
                <div className="bb-button bb-btn-default">
                    <a href={`${subscription_url}?${urlparams.toString()}`}>Starta bevakning</a>
                </div>
                <p className="mt-1"><a href="/bevakning/">Läs mer om vår bevakningstjänst</a></p>
            </div>
        )
    } else {
        return ''
    }
}

export default Subscription